import { Component, inject, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { InfoDialogComponent } from 'src/app/shared/icon-trigger-components/info-dialog/info-dialog.component';

@Component({
  selector: 'nova-icon-trigger',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './icon-trigger.component.html',
  styleUrl: './icon-trigger.component.scss'
})
export class IconTriggerComponent {
  title = input.required<string>();
  label = input.required<string>();
  body = input.required<string[]>();
  dialog = inject(MatDialog);

  openDialog(): void {
    this.dialog.open(InfoDialogComponent, {
      width: '525px',
      data: {
        title: this.title(),
        label: this.label(),
        body: this.body()
      }
    })
  };
}
